// journeys.
export enum JourneyTree {
  FR_JOURNEY_LOGIN = 'CMCLogin',
  FR_JOURNEY_LOGOUT = 'CMCLogout',
  FR_JOURNEY_FORGOT_PASSWORD = 'CMCForgotPassword',
  FR_JOURNEY_FORGOT_USERNAME = 'CMCForgottenUsername',
  FR_JOURNEY_CHANGE_PASSWORD = 'CMCChangePassword',
  FR_JOURNEY_CHANGE_USERNAME = 'CMCChangeUsername',
  FR_JOURNEY_REGISTER_MFA = 'CMCRegisterMFA',
  FR_JOURNEY_DISABLE_MFA = 'CMCDisableMFA',

  // AU Falcon Journeys
  FR_JOURNEY_LOGIN_V2 = 'CMCLoginV2',
  FR_JOURNEY_REGISTER_MFA_V2 = 'CMCRegisterMFAV2',
  FR_JOURNEY_DISABLE_MFA_V2 = 'CMCDisableMFAV2',
  FR_JOURNEY_FORGOT_PASSWORD_V2 = 'CMCForgotPasswordV2',
  FR_JOURNEY_FORGOT_USERNAME_V2 = 'CMCForgottenUsernameV2',
  FR_JOURNEY_CHANGE_PASSWORD_V2 = 'CMCChangePasswordV2',
  FR_JOURNEY_CHANGE_USERNAME_V2 = 'CMCChangeUsernameV2'
}

// journey action types.
export enum JourneyHandlerActionType {
  Login = 'Login',
  ForgotPassword = 'ForgotPassword',
  ForgotUsername = 'ForgotUsername',
  ChangePassword = 'ChangePassword',
  ChangeUsername = 'ChangeUsername',
  RegisterMfa = 'RegisterMfa',
  DisableMfa = 'DisableMfa'
}

// response screen stage.
export enum ScreenStage {
  Login = 'LOGIN',
  LoginV2Username = 'LOGIN_USERNAME',
  LoginV2Password = 'LOGIN_PASSWORD',
  LoginRetry = 'LOGIN_RETRY',
  RegisterMFAProfileCollector = 'REGISTER_MFA_PROFILE_COLLECTOR',
  MFARiskCheckProfileCollector = 'MFA_RISK_CHECK_PROFILE_COLLECTOR',
  StepupProfileCollector = 'STEPUP_PROFILE_COLLECTOR',
  RegisterMFAAuthOptions = 'REGISTER_MFA_AUTH_OPTIONS',
  RegisterMFAAuthApp = 'REGISTER_MFA_AUTH_APP',
  RegisterMFAEnterEmail = 'REGISTER_MFA_ENTER_EMAIL',
  RegisterMFAStart = 'REGISTER_MFA_START',
  InnerOTPResendOption = 'INNER_OTP_RESEND_OPTION',
  InnerOTPDecision = 'INNER_OTP_DECISION',
  RegisterMFAAnotherDevice = 'REGISTER_MFA_ANOTHER_DEVICE',
  RegisterMFAPushRegistration = 'REGISTER_MFA_PUSH_REGISTRATION',
  RegisterMFARecoveryCodes = 'REGISTER_MFA_RECOVERY_CODES',
  RequestMFAPushPollingWait = 'REQUEST_MFA_PUSH_POLLING_WAIT',
  RegisterMFAOathRegistration = 'REGISTER_MFA_OATH_REGISTRATION',
  RegisterMFAOathRecoveryCodes = 'REGISTER_MFA_OATH_RECOVERY_CODES',
  RegisterMFAOathRegistrationVerifier = 'REGISTER_MFA_OATH_REGISTRATION_VERIFIER',
  RequestMFAOathVerifier = 'REQUEST_MFA_OATH_VERIFIER',
  RequestMFAOk = 'REQUEST_MFA_OK',
  RequestMFAFail = 'REQUEST_MFA_FAIL',
  RequestMFARecoveryCodes = 'REQUEST_MFA_RECOVERY_CODES',
  RequestMFARecoveryCodesChoice = 'REQUEST_MFA_RECOVERY_CODES_CHOICE',
  RequestMFAOptions = 'REQUEST_MFA_OPTIONS',
  Recaptcha = 'RECAPTCHA',
  ForgotPasswordUsername = 'FORGOT_PASSWORD_USERNAME',
  ChangePasswordForced = 'CHANGE_PASSWORD_FORCED',
  ChangePasswordEnterNew = 'CHANGE_PASSWORD_ENTER_NEW',
  ChangePasswordCurrentPassword = 'CHANGE_PASSWORD_CURRENT_PASSWORD',
  ChangeUsernameEnter = 'CHANGE_USERNAME_ENTER',
  ChangePasswordEnterNewRetry = 'CHANGE_PASSWORD_ENTER_NEW_RETRY',
  ChangePasswordCurrentPasswordRetry = 'CHANGE_PASSWORD_CURRENT_PASSWORD_RETRY',
  ForgotUsernameDetails = 'FORGOT_USERNAME_DETAILS',
  ForgotUsernameEmailOk = 'FORGOT_USERNAME_EMAIL_OK',
  ForgotUsernameEmailFail = 'FORGOT_USERNAME_EMAIL_FAIL',
  DisableMFAConfirm = 'DISABLE_MFA_CONFIRM',
  PingOneProtectInitialize = 'PING_ONE_PROTECT_INITIALIZE',
  PingOneProtectEvaluation = 'PING_ONE_PROTECT_EVALUATION',
  Unknown = 'UNKNOWN'
}

// special error code.
export enum ErrorMessageCode {
  CMCAccountInactive = 'ACCOUNT_INACTIVE',
  CMCAccountLocked = 'ACCOUNT_LOCKED',
  CMCBrandMismatch = 'BRAND_MISMATCH',
  CMCUserExitError = 'USER_EXIT_ERROR',
  Unknown = 'Unknown'
}
